module.exports = require("core-js-pure/stable/instance/reduce-right");